<template>
  <div class="container-fluid">
    <Loading v-if="loading"></Loading>
    <div class="row col flex-column p-4 mt-2" v-if="!loading">
      <section>
        <div
          class="content-center d-flex justify-content-center"
          v-if="solicitacaoCartaoEmAndamento()"
        >
          <p class="fs-2">Você já possui uma solicitação em andamento.</p>
          <strong>Situação:</strong>
          <span class="ml-1">{{ statusLabel() }}</span>

          <div class="d-flex justify-content-center mt-5">
            <button class="btn col-12" type="submit">
              <span>Falar com suporte</span>
              <img
                @click="whatsApp"
                class="ml-2"
                style="width: 22px"
                src="@/assets/images/whatsapp-brands.svg"
              />
            </button>
          </div>
        </div>
        <div
          class="content-center d-flex justify-content-center"
          v-if="cartaoFisicoDisponivel()"
        >
          <p class="fs-2">Você já possui uma cartão físico.</p>
          <strong>Situação:</strong>
          <span class="ml-1">{{ statusLabel() }}</span>

          <div class="d-flex justify-content-center mt-5">
            <button class="btn col-12" type="submit">
              <span>Falar com suporte</span>
              <img
                @click="whatsApp"
                class="ml-2"
                style="width: 22px"
                src="@/assets/images/whatsapp-brands.svg"
              />
            </button>
          </div>
        </div>
        <div v-if="podeSolicitarCartao()">
          <span>Atualize o seu endereço para entrega do cartão.</span>
          <hr />
          <div class="form-group">
            <label>CEP</label>
            <form
              class="input-group"
              v-on:submit.prevent="getByCep(solicitacaoCartao.endereco.cep)"
            >
              <input
                class="form-control"
                type="text"
                v-model="solicitacaoCartao.endereco.cep"
                v-mask="'#####-###'"
                pattern=".{9}"
                placeholder="00000-000"
                style="
                  border-bottom-right-radius: 0;
                  border-top-right-radius: 0;
                  box-shadow: none;
                "
              />
              <button
                class="btn"
                style="
                  border-bottom-left-radius: 0;
                  border-top-left-radius: 0;
                  box-shadow: none;
                "
                type="submit"
                :readonly="loadingCep"
              >
                <span v-if="!loadingCep">Buscar</span>

                <span
                  class="spinner-border"
                  role="status"
                  v-if="loadingCep"
                ></span>
              </button>
            </form>
            <small class="text-muted" v-if="cepNaoLocalizado"
              >CEP não localizado</small
            >
          </div>

          <form @submit.prevent="solicitarCartao">
            <div class="form-group">
              <label>Logradouro</label>
              <input
                type="text"
                class="form-control"
                v-model="solicitacaoCartao.endereco.endereco"
                required
              />
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Complemento</label>
              <input
                type="text"
                class="form-control"
                v-model="solicitacaoCartao.endereco.complemento"
                required
              />
            </div>

            <div class="form-group">
              <label for="exampleInputPassword1">Número</label>
              <input
                type="text"
                class="form-control"
                v-model="solicitacaoCartao.endereco.numero"
                required
              />
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Bairro</label>
              <input
                type="text"
                class="form-control"
                v-model="solicitacaoCartao.endereco.bairro"
                required
              />
            </div>

            <div class="form-group">
              <label for="exampleInputPassword1">Cidade</label>
              <input
                type="text"
                class="form-control"
                v-model="solicitacaoCartao.endereco.cidade"
                required
              />
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">UF</label>

              <select
                class="form-select form-control"
                required
                v-model="solicitacaoCartao.endereco.estado"
              >
                <option selected>Selecione</option>
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AP">AP</option>
                <option value="AM">AM</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MT">MT</option>
                <option value="MS">MS</option>
                <option value="MG">MG</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PR">PR</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RS">RS</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="SC">SC</option>
                <option value="SP">SP</option>
                <option value="SE">SE</option>
                <option value="RR">TO</option>
              </select>
            </div>
            <div class="d-flex justify-content-center mt-3">
              <button class="btn col-6" type="submit">Solicitar Cartão</button>
            </div>
          </form>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Loading from "@/components/Loading.vue";
import { ApiCartoesService } from "@/service/carteira-digital/ApiCartoesService.js";
import { APIService } from "@/APIService";
const apiService = new APIService();
const cartoesService = new ApiCartoesService();

export default {
  name: "SolicitarCartaoBeneficio",
  components: {
    Loading,
  },
  data() {
    return {
      solicitacaoCartao: {},
      isPodeSolicitarCartao: false,
      isSolicitacaoCartaoEmAndamento: false,
      loading: true,
      loadingCep: false,
      cepNaoLocalizado: false,
    };
  },
  mounted() {
    this.loadDadosSolicitacaoCartao();
  },

  methods: {
    statusLabel() {
      let status = "";
      switch (this.solicitacaoCartao.cartao.statusCartaoFisico.status) {
        case "CARTAO_FISICO_SOLICITADO":
          status = "Cartão solicitado";
          break;
        case "CARTAO_FISICO_ENVIADO_PARA_IMPRESSAO":
          status = "Enviado para impressão";
          break;
        case "CARTAO_FISICO_AGUARDANDO_DESBLOQUEIO":
          status = "Aguardando desbloqueio";
          break;
        case "CARTAO_FISICO_DESBLOQUEADO":
          status = "Cartão desbloqueado";
          break;
        case "CARTAO_FISICO_BLOQUEADO":
          status = "Cartão bloqueado";
          break;

        case "CARTAO_FISICO_ATIVO":
          status = "Cartão ativo";
          break;
      }
      return status;
    },
    whatsApp() {
      window.location.href = window.WHATSAPP;
    },
    cartaoFisicoDisponivel() {
      const statusAtual =
        this.solicitacaoCartao.cartao.statusCartaoFisico.status;

      let retorno =
        !this.solicitacaoCartaoEmAndamento() &&
        (statusAtual == "CARTAO_FISICO_AGUARDANDO_DESBLOQUEIO" ||
          statusAtual == "CARTAO_FISICO_DESBLOQUEADO" ||
          statusAtual == "CARTAO_FISICO_BLOQUEADO" ||
          statusAtual == "CARTAO_FISICO_ATIVO");

      return retorno;
    },
    podeSolicitarCartao() {
      let retorno =
        this.solicitacaoCartao.cartao.statusCartaoFisico.status ==
        "CARTAO_FISICO_NAO_SOLICITADO";

      return retorno;
    },
    solicitacaoCartaoEmAndamento() {
      const statusAtual =
        this.solicitacaoCartao.cartao.statusCartaoFisico.status;

      let retorno =
        !this.podeSolicitarCartao() &&
        (statusAtual == "CARTAO_FISICO_SOLICITADO" ||
          statusAtual == "CARTAO_FISICO_ENVIADO_PARA_IMPRESSAO");

      return retorno;
    },
    solicitarCartao() {
      this.loading = true;
      cartoesService
        .solicitacaoCartao(this.solicitacaoCartao)
        .then(() => {
          this.$router.push(`/carteira-digital/cartao/listar`);
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    loadDadosSolicitacaoCartao() {
      this.loading = true;
      cartoesService
        .getDadosSolicitacaoCartaoBeneficio(0)
        .then((res) => {
          this.solicitacaoCartao = res;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
    getByCep(cep) {
      this.cepNaoLocalizado = false;

      if (!this.loadingCep) {
        this.loadingCep = true;
        apiService
          .getCep(cep)
          .then((res) => {
            if (res != "") {
              this.solicitacaoCartao.endereco.bairro = res.bairro;
              this.solicitacaoCartao.endereco.cidade = res.cidade;
              this.solicitacaoCartao.endereco.complemento = res.complemento;
              this.solicitacaoCartao.endereco.endereco = res.endereco;
              this.solicitacaoCartao.endereco.estado = res.estado;
              this.solicitacaoCartao.endereco.numero = res.numero;
              this.loadingCep = false;
            } else {
              this.loadingCep = false;
              this.cepNaoLocalizado = true;
            }
          })
          .catch(() => {
            this.loadingCep = false;
            this.cepNaoLocalizado = true;
          })
          .finally(() => {});
      }
    },
  },
};
</script>
<style scoped lang="scss">
.gerenciar-cartoes {
  background-color: #f2f2f2;
}

.content-center {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
</style>
